export default __webpack_public_path__ + "static/media/3132 knife block C top.f7324b45.png";